import React, { useCallback, useContext, useState } from "react";
import CreateEventDefinitionModal from "views/logic/valueactions/createEventDefinition/CreateEventDefinitionModal";
import useMappedData from "views/logic/valueactions/createEventDefinition/hooks/useMappedData";
import useModalData from "views/logic/valueactions/createEventDefinition/hooks/useModalData";
import { ActionContext } from "views/logic/ActionContext";
const CreateEventDefinition = ({ value, field, queryId, type, onClose }) => {
  const contexts = useContext(ActionContext);
  const mappedData = useMappedData({ contexts, field, queryId, type, value });
  const modalData = useModalData(mappedData);
  const [show, setShow] = useState(true);
  const handleOnClose = useCallback(() => {
    setShow(false);
    onClose();
  }, [onClose]);
  return show ? /* @__PURE__ */ React.createElement(CreateEventDefinitionModal, { modalData, mappedData, onClose: handleOnClose, show }) : null;
};
export default CreateEventDefinition;
